import * as React from 'react';
import {Helmet} from 'react-helmet';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {colors} from 'shells/colors/colors';
import {ErrorMessage} from 'shells/form/error-message';
import {PreAuthLayout} from 'shells/layout/pre-auth-layout';
import {Link} from 'shells/link/link';
import {Subheader} from 'shells/typography/subheader';

import styles from './verify-sender-page.module.css';

export class VerifySenderPage extends React.PureComponent<ContextRouter> {
    render() {
        const {location} = this.props;

        let title = 'Success!';
        let message = 'You can now send email outreach through Nutshell.';
        if (location.pathname.endsWith('/failure')) {
            title = 'Uh Oh!';
            // @ts-expect-error
            message = (
                <ErrorMessage>
                    Something went wrong, please try again or contact support!
                </ErrorMessage>
            );
        }

        return (
            <PreAuthLayout
                backgroundColor={colors.navyLt}
                imageLeft={<img alt='' src='/include/images/auth/confirm-email.svg' />}
            >
                <Helmet>
                    <title>{title}</title>
                </Helmet>
                <div>
                    <Subheader as='p'>{message}</Subheader>
                    <div className={styles['back-to-nutshell-container']}>
                        <Link href='/dashboard' variant='button-primary' size='xlarge'>
                            Take me back to Nutshell
                        </Link>
                    </div>
                </div>
            </PreAuthLayout>
        );
    }
}
